import { render, staticRenderFns } from "./PostEditor.vue?vue&type=template&id=8eab31be&"
import script from "./PostEditor.vue?vue&type=script&lang=ts&"
export * from "./PostEditor.vue?vue&type=script&lang=ts&"
import style0 from "./PostEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports